

import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Divider, Grid } from '@mui/material';
import { Typography } from '@mui/material';
import { useAuth } from '../../../../hooks/useAuth';
import { delSellDoc, uploadSellDoc } from '../../../../services/material-services';
import {NotificationManager} from 'react-notifications';
import PropTypes from 'prop-types';
import { blue } from '@mui/material/colors';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function SellReqDoc({userClient, ReqUser, onClose}) {
    const { authData } = useAuth()
    // const { onClose, selectedValue, open } = props
    const [isAdmin, setIsAdmin] = useState(false)
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const [fileSelect, setFileSelect ] = useState(null)
    

    useEffect(()=>{
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }

        console.log("SellReqDoc", fileSelect)
        setFileSelect(ReqUser?.sell_req_buys?.sell_mat_files)

    }, [authData, ReqUser])

    const handelDel = async value => {
        if(value?.id){
            const delFile = await delSellDoc(authData.token, value.id)
            console.log("delFile", delFile)
        }
    }

    const handelSubmit = async value => {
        setLoading(true)
        let downloadFile = value.file.split("/").pop()
        axios({
            url: `${value.file}`,
            method: "GET",
            headers: {
                // 'Content-Type': 'multipart/form-data',
                'Authorization': `Token ${authData.token}`,
            },
            responseType: "blob" // important
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `${downloadFile}`
            );
            document.body.appendChild(link);
            link.click();
    
            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
        .catch(error => {
            console.error(error);
        });
        // await downloadSellDoc(authData.token, value.id)
        // .then(response => {
        //     const url = window.URL.createObjectURL(new Blob([response]));
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute(
        //         "download",
        //         `${this.props.file.name}.${this.props.file.mime}`
        //     );
        //     document.body.appendChild(link);
        //     link.click();
    
        //     // Clean up and remove the link
        //     link.parentNode.removeChild(link);
        // });
        // e.preventDefault()
        // // const dateMiladi = moment(entryTime, 'jYYYY/jM/jD').format('YYYY-M-D')
        // // console.log("sellID", data)
        // let addNewSellMat = ''
        // // let addNewCredit = ''
        // if(sellID <= 0){
        //     const data = {user: userClient.id, material:matName.id, req_buy: ReqUser.id
        //                 , name_project: projectName, order_number: numberOrder, bio: moreDetail
        //                 , lang_programs: programmerLang,  
        //                 remarks: remarks}
        //     addNewSellMat = await addSellMaterial(authData.token, data)
        //     setNumberOrder(addNewSellMat?.order_number)
        //     // console.log("addNewSellMat:", addNewSellMat)
        //     addNewSellMat = await addSellCredit(authData.token, 
        //             {sell_mat: addNewSellMat.id, estimate_credit: estimateCredit, 
        //             total_credit: totalCredit})
                        
        // }else{
        //     const data = {user: userClient.id, material:matName.id, req_buy: ReqUser.id
        //                 , name_project: projectName, bio: moreDetail
        //                 , lang_programs: programmerLang, remarks: remarks}
        //     addNewSellMat = await setSellMaterial(authData.token, sellID, data)
        //     // console.log(addNewSellMat)
        //     addNewSellMat = await setSellCredit(authData.token, creditID, 
        //         {sell_mat:sellID, estimate_credit: estimateCredit, total_credit: totalCredit})

        // }
        // // const dataBack = { 'bio_step': bio_step, "expire_time": expire_time, "detail_id": detail_id}
        // // onClose(addNewBuyMaterial)
        // // console.log("addNewBuyMaterial", addNewBuyMaterial)
        // if (downloadFile){
        //     NotificationManager.success('جزئیات جدید به برنامه اضافه شد')
        // }else{
        //     NotificationManager.error('متاسفانه خطایی در زمان ثبت جزئیات وجود دارد')
        // }
        setLoading(false)
    }

    const handlerFiles = async value => {
        // console.log(value)
        const uploaddata = new FormData()
        if(value){
            setLoading(true)
            uploaddata.append('file', value, value.name)
            uploaddata.append('sell_mat', ReqUser.id)
            const uploadDoc = await uploadSellDoc(authData.token, uploaddata)
            // console.log(addNewMaterial);
            if (uploadDoc){
                NotificationManager.success('فایل جدید به برنامه اضافه شد')
            }else{
                NotificationManager.error('متاسفانه خطایی در زمان ثبت فایل وجود دارد')
            }
            
            setLoading(false)
        }
        
        
    }

  return (
    <div style={{direction: 'rtl'}}>
        <Accordion sx={{backgroundColor: blue[900], margin: 1}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{color: 'pink.text'}}/>}
                aria-controls="panel2a-content"
                id="panel2a-header"
                >
                <Typography
                    fontFamily='b_mitra' 
                    component="div"
                    variant="h6"
                    color={"pink.text"}
                    >
                    اسناد و فایل ها 
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{backgroundColor: 'white', padding: 10}} >
                    <br/>
                    <Button 
                        component="label" 
                        variant="contained" 
                        startIcon={<CloudUploadIcon />}
                        >
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'pink.text'}
                            >
                            بارگذاری اسناد
                        </Typography>
                        <VisuallyHiddenInput type="file" onChange={e => handlerFiles(e.target.files[0])}/>
                    </Button>
                    <br />
                    <Divider />
                    <br />
                    <Grid container sx={{marginTop: 1, marginRight:1, marginLeft:1}}>
                        {fileSelect?.map((files) => (
                            <Grid container spacing={1} alignItems='flex-end'>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    {isAdmin &&
                                        <Grid item>
                                            <Button 
                                                variant="contained" 
                                                color="secondary"
                                                size="small" 
                                                sx={{margin: 1}}
                                                startIcon={<ClearIcon />}
                                                onClick={e => handelDel(files)}
                                                >
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={'pink.text'}
                                                    >
                                                    حذف
                                                </Typography>
                                            </Button>
                                        </Grid>
                                    }
                                    <Grid item xs={4}>
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            {files.file.split('/').pop()}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                    {/* <a href={files.file} target="_blank" rel="noreferrer" download> */}
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            size="small" 
                                            startIcon={<CloudUploadIcon />}
                                            onClick={e => handelSubmit(files)}
                                            >
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={'pink.text'}
                                                >
                                                دانلود
                                            </Typography>
                                        </Button>
                                    {/* </a> */}

                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </AccordionDetails>
        </Accordion>
    </div>
  )
}


SellReqDoc.propTypes = {
    onClose: PropTypes.func.isRequired,
    // open: PropTypes.bool.isRequired,
    // selectedValue: PropTypes.string.isRequired,
}